import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { FormInput } from '../forms/final-form-fields'

export default function RedirectMethods({
  currentMethod,
  errorsRef,
  isLoading,
  unconfirmedOrder,
}) {
  return (
    <Fragment>
      {!unconfirmedOrder ? (
        <div>
          <div className='payment-block text-left clearfix'>
            <form name='redirectForm'>
              <p className='title'>
                <FormattedMessage
                  id='customer_info'
                  defaultMessage='Customer info'
                />
              </p>
              <div className='form-group'>
                <FormInput
                  name='redirectName'
                  isRequired
                  label={
                    <FormattedMessage
                      id='full_name'
                      defaultMessage='Full name'
                    />
                  }
                />
              </div>
              {currentMethod === 'ideal' && (
                <div className='form-group new-section'>
                  <label>
                    <FormattedMessage
                      id='ideal_bank'
                      defaultMessage='iDEAL Bank'
                    />
                    &nbsp;<span className='asterisk'>*</span>
                  </label>
                  <div id='ideal-bank-element' />
                </div>
              )}
              <div className='error-msg stripe-errors' ref={errorsRef} />
            </form>
          </div>
          <div className='payment-submit'>
            <button
              className='btn-red'
              ng-click='ctrl.submitRedirectForm(redirectForm)'
            >
              <FormattedMessage id='pay_now' defaultMessage='Pay now' />
            </button>
          </div>
        </div>
      ) : (
        <div className='payment-methods-list__inner'>
          <FormattedMessage
            tagName='p'
            id='redirect_payment_save'
            defaultMessage='You will be able to pay using this payment method when your order is confirmed (usually within 24h of your booking request).'
          />
        </div>
      )}
    </Fragment>
  )
}
